import React from 'react'

const Airbags = ({ width = '50px', height = '46px', color }) => (
  <svg viewBox="0 0 50 46" version="1.1" width={width} height={height}>
    <title>Icon/Dashboard/ABS Copy</title>
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="Interior_Lights_D" transform="translate(-490.000000, -643.000000)" stroke={color}>
        <g id="Group" transform="translate(483.000000, 634.000000)">
          <g id="ICOPath-Airbags" transform="translate(8.000000, 10.400000)">
            <circle id="Oval" strokeWidth="1.10012783" cx="16.4" cy="9.2" r="9.2"></circle>
            <circle id="Oval" strokeWidth="1.10012783" cx="34" cy="9.2" r="4.4"></circle>
            <ellipse id="Oval" strokeWidth="1.100189" transform="translate(44.400000, 13.200000) rotate(-50.884741) translate(-44.400000, -13.200000) " cx="44.4" cy="13.2" rx="4.4" ry="2"></ellipse>
            <path
              d="M33.0758002,14.4466258 C33.0758002,14.4466258 26.6996782,16.633644 26.4,21.8005252 C26.4,21.8005252 29.0953284,29.7816338 29.8945072,31.2 C29.8945072,31.2 31.8776422,30.0115206 33.0851201,28.2722357 C34.2927089,26.5330634 36.1044249,22.5645638 36.4722269,20.1199779 C36.8400289,17.675392 37.7709063,13.9400424 33.0758002,14.4466258 Z"
              id="Path"
              strokeWidth="1.10012783"></path>
            <path
              d="M15.2371089,24.3178631 C14.1924636,22.233065 10.0162388,23.3497314 8.66687264,25.3346947 C7.31750649,27.3197687 4.0787809,32.0116711 0.958308574,36.7300265 C-2.16216375,41.4483819 3.10964273,44.5201275 5.77078979,40.629781 C8.43193685,36.7394344 12.000515,32.0115604 12.000515,32.0115604 C12.000515,32.0115604 15.3908157,34.1697404 17.5418132,35.382257 C19.6928108,36.5947736 20,35.5337801 20,35.5337801 C20,35.5337801 16.2817541,26.4025505 15.2371089,24.3178631 Z"
              id="Path"
              strokeWidth="1.10012783"></path>
            <path
              d="M28.4067031,43.1077363 L29.4227271,42.7406875 C30.1992646,42.460119 30.5959034,41.6198367 30.3040328,40.8732597 L23.1359503,22.5394298 C22.8440797,21.7929623 21.9699483,21.4116826 21.1932969,21.692251 L20.1772729,22.0592998 C19.4007354,22.3398683 19.0040966,23.1801506 19.2959672,23.9267276 L26.4640497,42.2605575 C26.7560341,43.0071345 27.6301655,43.3883047 28.4067031,43.1077363 Z"
              id="Path"
              strokeWidth="1.25951435"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export default Airbags
